import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Funder } from 'src/app/core/models/funder';

@Component({
  selector: 'app-feature-icon',
  templateUrl: './feature-icon.component.html',
  styleUrls: ['./feature-icon.component.scss']
})
export class FeatureIconComponent {
  @Input() url!: string;
  @Input() title!: string;
  @Input() iconName!: string

  constructor(
    private router: Router,
  ) {

  }

  getBackgroundColor() {
    return this.adjustColor(this.getColor(), 0.2);
  }


  getColor() {
    const fundersList = JSON.parse(localStorage.getItem('funders_list')!).map((el: any) => new Funder(el)).filter((el: Funder) => el.logo_path);
    const currentFunderDomain = localStorage.getItem('current_portal_domain');
    const currentFunder = fundersList.filter((el: any) => el.funder_settings.domain == currentFunderDomain)[0];
    return currentFunder.primary_color;
  }

  adjustColor(color: string, opacity: number) {
    let r = parseInt(color.substring(1, 3), 16);
    let g = parseInt(color.substring(3, 5), 16);
    let b = parseInt(color.substring(5, 7), 16);

    // Convert opacity to alpha value (0-255)
    let alpha = Math.round(opacity * 255);

    // Convert the RGB values to rgba format
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  navigatorTo() {
    this.router.navigateByUrl(this.url)
  }
}
